import api from './api';

export interface ChaseResult {
  success: boolean;
  message: string;
  outcome: 'success' | 'jailed' | 'failed' | 'continue';
  rankPointsEarned?: number;
  moneyEarned?: number;
  moneyLost?: number;
  healthLost?: number;
  jailTime?: number;
  nextDecision?: {
    location: string;
    options: string[];
  };
}

export interface ChaseDecision {
  location: string;
  options: string[];
}

class ChaseService {
  /**
   * Start a new chase sequence
   */
  async startChase(): Promise<ChaseResult> {
    try {
      const response = await api.post('/chase/start');
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to start chase');
    }
  }

  /**
   * Make a decision during the chase
   */
  async makeDecision(decisionIndex: number): Promise<ChaseResult> {
    try {
      const response = await api.post('/chase/decision', { decisionIndex });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to make decision');
    }
  }

  /**
   * Handle timer timeout - player is caught
   */
  async handleTimerTimeout(): Promise<ChaseResult> {
    try {
      const response = await api.post('/chase/timeout');
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to handle timer timeout');
    }
  }

  /**
   * Reset chase cooldown timer (for testing)
   */
  async resetChaseTimer(): Promise<{ success: boolean; message: string }> {
    try {
      const response = await api.post('/chase/reset-timer');
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to reset chase timer');
    }
  }
}

export const chaseService = new ChaseService();
